import { defineMessage } from 'services/localization';

export const messages = {
    connectToOrgDescribe1: defineMessage('approvalmax_wont_change_approving_the_documents'),
    connectToOrgDescribe2: defineMessage('your_data_is_safe_with_us'),
    tooltip1: defineMessage('the_approvalmax_connect__your_accounting_system'),
    tooltip2: defineMessage('protecting_financial_in_t_centertrustcenterlink'),
};
